module.exports = __webpack_public_path__ + "img/menu5.2eb6e1c4.png";